import React from 'react';
import RouteMap from '../../components/RouteMap';
import Template from '../../components/Template';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';


export default function RouteVehicles({ route, tripId, plate, onBack, titleTranslate }) {
    return (
        <Template type={4} classNameContainer="route" className="container_menu route">
            <div className="content_dynamic mt-5">
                <Row>
                    <Col>
                        <button
                            onClick={onBack}
                            className="btn-secondary-dark register"
                            style={{ marginBottom: '20px' }}
                        >
                            ← {titleTranslate('vehiclesTrips.back')}
                        </button>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <h2 className="trips-title route-map">
                            {titleTranslate('vehiclesTrips.trip')} #{tripId} {titleTranslate('vehiclesTrips.for_vehicle')} <strong>{plate}</strong>
                        </h2>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <RouteMap route={route} />
                    </Col>
                </Row>
            </div>
        </Template>
    );
}